import React from 'react';
import PropTypes from 'prop-types';

let SemiCircleProgress = function SemiCircleProgress(_ref) {
    let _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === undefined ? "#FBAB5B" : _ref$stroke,
        _ref$strokeWidth = _ref.strokeWidth,
        strokeWidth = _ref$strokeWidth === undefined ? 20 : _ref$strokeWidth,
        _ref$background = _ref.background,
        background = _ref$background === undefined ? "#BDBDBD" : _ref$background,
        _ref$diameter = _ref.diameter,
        diameter = _ref$diameter === undefined ? 200 : _ref$diameter,
        _ref$orientation = _ref.orientation,
        orientation = _ref$orientation === undefined ? "up" : _ref$orientation,
        _ref$direction = _ref.direction,
        direction = _ref$direction === undefined ? "right" : _ref$direction,
        _ref$showPercentValue = _ref.showPercentValue,
        showPercentValue = _ref$showPercentValue === undefined ? false : _ref$showPercentValue,
        currentValue = _ref.currentValue,
        maxValue = _ref.maxValue,
        minValue = _ref.minValue;


    let percentage = 0;
    let coordinateForCircle = diameter / 2;
    let radius = (diameter - 2 * strokeWidth) / 2;
    let circumference = Math.PI * radius;

    let percentageValue = void 0;
    if (percentage > 100) {
        percentageValue = 100;
    } else if (percentage < 0) {
        percentageValue = 0;
    } else {
        percentageValue = (currentValue / (maxValue - minValue)) * 100;
        console.log(percentageValue)
    }
    let semiCirclePercentage = percentageValue * (circumference / 100);

    let rotation = void 0;
    if (orientation === "down") {
        if (direction === "left") {
            rotation = "rotate(180deg) rotateY(180deg)";
        } else {
            rotation = "rotate(180deg)";
        }
    } else {
        if (direction === "right") {
            rotation = "rotateY(180deg)";
        }
    }

    return React.createElement(
        "div",
        {className: "semicircle"},
        React.createElement(
            "div",
            {className: "semicircle-container", style: {position: "relative"}},
            React.createElement(
                "svg",
                {
                    width: diameter,
                    height: diameter / 2,
                    style: {transform: rotation, overflow: "hidden"}
                },
                React.createElement("circle", {
                    cx: coordinateForCircle,
                    cy: coordinateForCircle,
                    r: radius,
                    fill: "none",
                    stroke: background,
                    strokeWidth: strokeWidth,
                    strokeDasharray: circumference,
                    style: {
                        strokeDashoffset: circumference
                    }
                }),
                React.createElement("circle", {
                    cx: coordinateForCircle,
                    cy: coordinateForCircle,
                    r: radius,
                    fill: "none",
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: circumference,
                    style: {
                        strokeDashoffset: semiCirclePercentage,
                        transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s"
                    }
                }),
            ),
            React.createElement(
                "div",
                {
                    className: 'semi-circle-text-box', style: {
                        width: "100%",
                        left: "0",
                        textAlign: "center",
                        bottom: "-20px",
                        position: "absolute"
                    }
                },
                React.createElement(
                    "span",
                    {
                        className: "semicircle-percent-value",
                    },
                    "150000"
                ),
                React.createElement(
                    "p",
                    {
                        className: "semicircle-percent-value-text",
                    },
                    "بازدید"
                ),
            )
        ),
        React.createElement(
            "div",
            {className: "semicircle-indicators"},
            React.createElement(
                "span",
                {className: "semicircle-indicators-text"},
                `${maxValue} بازدید`
            ),
            React.createElement(
                "span",
                {className: "semicircle-indicators-text"},
                `${minValue} بازدید`
            )
        )
    );
};

SemiCircleProgress.propTypes = {
    stroke: PropTypes.string,
    strokeWidth: PropTypes.number,
    background: PropTypes.string,
    diameter: PropTypes.number,
    orientation: PropTypes.oneOf(["up", "down"]),
    direction: PropTypes.oneOf(["left", "right"]),
    showPercentValue: PropTypes.bool,
    currentValue: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
};

export default SemiCircleProgress;